export default __webpack_public_path__ + "static/media/wallet-product-yield-vault.acf7a0d7.svg";